import React, { useId, useState } from "react"; // import hooks
import { VscEye, VscEyeClosed } from "react-icons/vsc"; // import icons

const Input = React.forwardRef(function Input(
{
    label,
    type = "text",
    className = "",
    ...props
}, ref) {

    const id = useId(); // create unique id
    const [showPassword, setShowPassword] = useState(false); // state to toggle password

    // toggle function
    const togglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <div className="w-full flex flex-col relative">

            <input
                type={type === "password" ? (showPassword ? "text" : "password") : type} // change type when toggled
                className={`w-full px-3  font-Montserrat py-2 border border-black rounded-md ${className}`}
                placeholder={label && label}
                {...props}
                ref={ref}
                id={id}
            />

            {/* show eye icon only for password */}
            {type === "password" && (
                <span
                    className="absolute right-3 top-2.5 cursor-pointer"
                    onClick={togglePassword}
                >
                    {showPassword ? <VscEye /> : <VscEyeClosed />}
                </span>
            )}

        </div>
    );
});

export default Input;